module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "contents"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "ahead"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Contents"), _c('a', {
    attrs: {
      "id": "x-contents-anchor"
    }
  })])]), _c('a', {
    attrs: {
      "id": "x-contents-anchor"
    }
  }), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "x-contents-anchor"
    }
  }, [_c('span', {
    staticClass: "ital"
  })]), _c('a', {
    attrs: {
      "href": "#/The_Blessing_Prayer#anchor-anchor"
    }
  }, [_vm._v("The Blessing Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "ital"
  }, [_c('a', {
    attrs: {
      "href": "#/How_to_Use_This_Book#how-to-use-this-book-anchor"
    }
  }, [_vm._v("How To Use This Book")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('a', {
    attrs: {
      "href": "#/Words_From_the_Old_Ones#words-from-the-old-ones-anchor"
    }
  }, [_vm._v("Words from the Old Ones")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('a', {
    attrs: {
      "href": "#/Calling_the_God_and_Goddess#calling-the-god-and-goddess-anchor"
    }
  }, [_vm._v("Calling the God and Goddess")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('a', {
    attrs: {
      "href": "#/Creating_Sacred_Space#creating-sacred-space-anchor"
    }
  }, [_vm._v("Creating Sacred Space")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/The_Sabbats#the-sabbats-anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sabbats")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Full_Moon_Rites#full-moon-rites-anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Full Moon Rites")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Prayers_Chants_and_Invocations#prayers-chants-and-invocations-anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayers, Chants, and Invocations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Rites_and_Lore#rites-and-lore-anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rites and Lore")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Recipes_for_the_Feast#recipes-for-the-feast-anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recipes for the Feast")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/An_Herbal_Grimoire#an-herbal-grimoire-anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Herbal Grimoire")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Herbal_Recipes_and_Secrets#herbal-recipes-and-secrets-anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Herbal Recipes and Secrets")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Incenses#incenses-anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Incenses")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Oils#oils-anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oils")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Magical_Lore_Spells_and_Rituals#magical-lore-spells-and-rituals-anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Magical Lore, Spells, and Rituals")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Systems_of_Power#systems-of-power-anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Systems of Power")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Rune_Magic#rune-magic-anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rune Magic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Signs_and_Symbols#signs-and-symbols-anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Signs and Symbols")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "ital"
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography#bibliography-anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "ital"
  }, [_c('span', {
    attrs: {
      "href": "#/Appendix_I#appendix-i-anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix I")]), _vm._v(" by deTraci Regula")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "ital"
  }, [_c('span', {
    attrs: {
      "href": "#/Appendix_II#appendix-ii-anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix II")]), _vm._v(" by Marilee Bigelow ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "ital"
  }, [_c('span', {
    attrs: {
      "href": "#/Appendix_III#apendix-iii-anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apendix III")]), _vm._v(" by Christine Ashworth ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "ital"
  }, [_c('span', {
    attrs: {
      "href": "#/Appendix_IV#appendix-iv-anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix IV")]), _vm._v(" by David Harrington")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0